<template>
  <div>
    <v-data-table
      v-model="payload.selection"
      :headers="headers"
      :must-sort="true"
      :loading="payload.loading"
      :item-key="payload.list.id"
      :items="payload.list"
      :footer-props="paginationList"
      :show-select="payload.showSelect"
      :show-expand="payload.expand"
      :single-expand="false"
      :expanded.sync="payload.expanded"
      :search="!total ? search : undefined"
      :no-data-text="$t('global.no_data_text')"
      :server-items-length="payload.isNormalPagination ? undefined : total ? total : undefined"
      :options.sync="paginationMap"
      dense
      class="elevation-1 table table-hover"
    >
      <template #[`item.data-table-select`]="{ isSelected, select }">
        <v-simple-checkbox :ripple="false" color="primary" :value="isSelected" @input="select($event)"></v-simple-checkbox>
      </template>
      <template v-slot:item.type="{ item }">
        {{ $dd_property_types(item.type_id) }}
      </template>
      <template v-slot:top>
        <v-toolbar
          :elevation="!!payload.selection.length ? 5 : 0"
          :color="!!payload.selection.length ? 'primary' : 'white'"
          v-if="!payload.hideSearch || payload.selection.length"
        >
          <template v-if="!payload.selection.length">
            <template class="mt-0">
              <v-flex sm8 xs4 v-if="!payload.hasFilters">
                <action-button v-if="!payload.isHideAdd" :disabled="payload.noAdd" type="new" id="newbtn" @click="payload.addNewRoute" />
                <action-button v-else-if="payload.addClickHandler" :disabled="payload.noAdd" type="new" id="newbtn" @click="payload.addClickHandler" />
              </v-flex>
              <v-flex sm10 xs12>
                <slot name="filterForm" v-if="payload.hasFilters"></slot>
              </v-flex>
              <v-flex sm4 xs12 v-if="!payload.hasFilters">
                <v-text-field
                  autocomplete="new-password"
                  append-icon="mdi-search"
                  single-line
                  v-model="search"
                  label="Search"
                  class="mt-4 text-xs-right"
                  id="searchbtn"
                ></v-text-field>
              </v-flex>
              <v-flex sm2 xs12 v-if="!payload.hideSearch && payload.hasFilters">
                <v-text-field
                  autocomplete="new-password"
                  append-icon="mdi-search"
                  single-line
                  v-model="search"
                  label="Search"
                  class="mt-4 text-xs-right"
                  id="searchbtn"
                ></v-text-field>
              </v-flex>
            </template>
          </template>
          <v-slide-y-transition v-if="payload.selection.length">
            <v-btn icon @click="payload.selection = []">
              <v-icon color="white">close</v-icon>
            </v-btn>
          </v-slide-y-transition>
          <v-slide-y-transition>
            <v-toolbar-title v-if="payload.selection.length">
              <div class="white--text">
                {{ `${payload.selection.length} ${$t("checklistapi.common.selected")}` }}
              </div>
            </v-toolbar-title>
          </v-slide-y-transition>
          <v-spacer v-if="payload.selection.length"></v-spacer>
          <template v-if="payload.selection.length">
            <v-slide-y-transition>
              <v-btn rounded @click="deleteEntries" class="black--text" color="white" key="delete"
                ><!--  :disabled="disableDelete" -->
                {{ $t("global.delete") }}
              </v-btn>
            </v-slide-y-transition>
          </template>
        </v-toolbar>
      </template>
      <template #[`item.${payload.htmlProp}`]="{ item }">
        <div style="text-align: justify;">
          <span v-html="item[payload.htmlProp]"></span>
        </div>
      </template>
      <template #[`item.${payload.editProp}`]="{ item }">
        <template>
          <a
            v-if="payload.is_checklist"
            @click="payload.editHandler(item.checklist_id, item.form_id, item.id, item.equipment_id, item)"
            class="underline"
            >{{ item[payload.editProp] }}</a
          >
          <a v-else @click="payload.editHandler(item.id)" class="underline">{{ item[payload.editProp] }}</a>
        </template>
      </template>
      <template v-for="(field, index) in booleanItems" #[`item.${field}`]="{ item }">
        <v-icon class="font--style" :key="index">
          {{ item[field] ? "check" : "close" }}
        </v-icon>
      </template>
      <template v-slot:expanded-item="{ item, headers }">
        <td :colspan="headers.length">
          <template v-if="payload.expandHeader">
            <v-simple-table dense width="100%" class="dense_table bordered--table">
              <thead>
                <tr>
                  <th v-for="(headers, index) in payload.expandHeader" :key="index">
                    {{ headers.text }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(product, i) in item[payload.expandItem]" :key="i">
                  <td v-for="(headers, index) in payload.expandHeader" :key="index">
                    {{ product[`${headers.value}`] }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </template>
          <slot name="expand" v-else></slot>
        </td>
      </template>
      <template #[`item.actions`]="{ item }">
        <v-btn
          icon
          v-for="(action, index) in payload.actionsList"
          text
          v-show="action.is_show !== undefined ? action.is_show(item) : true"
          class="pa-0 action--btns ml-1"
          :color="action.color ? action.color(item) : ''"
          @click="action.click(item)"
          :key="index"
        >
          <v-icon>{{ action.icon(item) }}</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
export default {
  props: ["payload", "pagination", "total", "headers"],
  model: {
    prop: "pagination",
    event: "change"
  },
  data() {
    return {
      paginationList: {
        itemsPerPageOptions: [10, 25, 50, 100, -1]
      },
      paginationMap: {
        ...this.pagination,
        itemsPerPage: +window.localStorage.getItem("pagination_count") || 25
      },
      search: "",
      booleanItems: [],
      disableUniExport: false
    }
  },
  watch: {
    paginationMap(newValue) {
      if (!this.payload.isNormalPagination) {
        if (!this.$format.isEmptyObject(newValue)) {
          const result = Object.assign({ ...this.paginationMap }, { search: this.search })
          if (result && result.itemsPerPage) {
            window.localStorage.setItem("pagination_count", result.itemsPerPage)
          }
          this.$emit("change", result)
        }
      }
    },
    search(val) {
      if (!this.payload.isNormalPagination) {
        const search = Object.assign({ ...this.paginationMap }, { search: val })
        this.$emit("change", search)
      }
    },
    "payload.selection"(val) {
      if (val) {
        const selectedItems = this.payload.selection.map((x) => x)
        if (this.payload.module === "invoices") {
          const exported = selectedItems.find((x) => x.exported_for_uni)
          if (exported) this.disableUniExport = true
          else this.disableUniExport = false
        }
      }
    }
  },
  mounted() {
    this.getBooleanItems()
  },
  methods: {
    exportIds() {
      const ids = this.payload.selection.map((x) => x.id)
      this.payload.export(ids)
    },
    getBooleanItems() {
      const booleanList = this.headers.filter((x) => x.isBoolean)
      this.booleanItems = booleanList.map((x) => x.value)
    },
    deleteEntries() {
      const ids = this.payload.selection.map((x) => x.id)
      const data = { module: this.payload.module, ids }
      this.$eventBus.$emit("deleteItems", data)
    }
  }
}
</script>
<style>
.action--btns.v-btn--icon.v-size--default {
  height: 25px !important;
  width: 25px !important;
}
.underline {
  text-decoration: underline;
}
</style>
